module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/array-buffer-native.js
// module id = jqyf
// module chunks = a74a